<template>
  <div id="TabBar" class="tab-bar row">
    <div class="" @click="didClickedItem(0,'/first')" v-bind:class="{active: this.$route.path === '/first'}">
      <div class="row">

      </div>
      <div class="row">
        <span>首页</span>
      </div>
    </div>
    <div class="" @click="didClickedItem(1,'/query')" v-bind:class="{active: this.$route.path === '/query'}">
      <div class="row">

      </div>
      <div class="row">
        <span>查询服务</span>
      </div>
    </div>
    <div class="" @click="didClickedItem(2,'/ywbl')" v-bind:class="{active: this.$route.path === '/ywbl'}">
      <div class="row">

      </div>
      <div class="row">
        <span>业务办理</span>
      </div>
    </div>
    <div class="" @click="didClickedItem(3,'/my')" v-bind:class="{active: this.$route.path === '/my'}">
      <div class="row">

      </div>
      <div class="row">
        <span>我的</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabBar',
  props: {

  },
  data: function () {
    return {
      /* actives: [true, false, false, false] */
    }
  },
  methods: {
    didClickedItem: function (tag, url) {
      /* this.actives = this.actives.map(function () {
        return false
      })
      this.actives[tag] = true */
      // this.$router.push(url)
      this.$emit('select-footer', tag, url)
    }
  }
}
</script>

<style scoped>
  #TabBar{
    display: flex;
    align-items: center;
  }
  #TabBar>div{
    flex: 1;
    text-align: center;
  }
  .tab-bar {
    background-color: white;
    height: 7vh;
    border: 0 solid rgb(210, 210, 210);
    border-top-width: 1px;
    position: fixed;
    margin: auto;
    bottom: 0;
    width: 100%;
  }

  .tab-bar-item {
    height: 54px;
  }

  .active {
    color: #3485fa;
  }
  .row{
    line-height: 100%;
  }
  i {
    font-size: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue